import { useCookie } from "#app";
import type { IToken } from "~/utils/interfaces/auth-interfaces";

// The `teams_*_token` cookie names are persisted across sessions: renaming them signs everyone out.
export const useTokens = () => {
  function getTokensFromCookies(): IToken | null {
    const teamsAccessToken = useCookie("teams_access_token");
    const teamsRefreshToken = useCookie("teams_refresh_token");

    if (teamsAccessToken.value && teamsRefreshToken.value) {
      return {
        accessToken: teamsAccessToken.value,
        refreshToken: teamsRefreshToken.value,
      };
    }
    return null;
  }

  function setCookiesTokens(tokens: IToken): void {
    const cookiesOpts = {
      expires: new Date(Date.now() + 24 * 60 * 60 * 1000),
      maxAge: 60 * 60 * 24,
      path: "/",
      secure: true, // ✅ Required for SameSite=None
      sameSite: "none" as const, // ✅ Essential for cross-domain iframe
      httpOnly: false,
    };

    const teamsAccessToken = useCookie("teams_access_token", cookiesOpts);

    const teamsRefreshToken = useCookie("teams_refresh_token", cookiesOpts);

    teamsAccessToken.value = tokens.accessToken;
    teamsRefreshToken.value = tokens.refreshToken;
  }

  function clearCookiesTokens() {
    const teamsAccessToken = useCookie("teams_access_token");
    const teamsRefreshToken = useCookie("teams_refresh_token");

    const teamsAccessTokenGlobal = useCookie("teams_access_token", {
      domain: "simbel.fr",
    });
    const teamsRefreshTokenGlobal = useCookie("teams_refresh_token", {
      domain: "simbel.fr",
    });

    teamsAccessToken.value = null;
    teamsRefreshToken.value = null;
    teamsAccessTokenGlobal.value = null;
    teamsRefreshTokenGlobal.value = null;
  }

  return { getTokensFromCookies, setCookiesTokens, clearCookiesTokens };
};
